import React from "react";
import {TooltipShop} from "./index";

const bigintFormatCompact = { notation: 'compact', maximumFractionDigits: 1 };
const bigintFormatScientific = { notation: 'scientific', maximumFractionDigits: 1 };

export default class StoreOption extends React.Component {
	pow = (n, p) => {
		if (!p)
			return 1n
		let r = n
		for (let i = 1 ; i < p ; i ++)
			r *= n
		return r
	}

	onClick = (price) => {
		if (this.props.influence >= (price * 1000n)) {
			this.props.onBuy()
			this.props.updateData({
				influence: this.props.influence - (price * 1000n),
				[`storeCount${this.props.num}`]: (this.props.count || 0n) + 1n
			})
		}
	}

	render() {
		const price = this.props.base * this.pow(115n, (this.props.count || 0n)) / this.pow(100n, (this.props.count || 0n))
		return (
			<TooltipShop text={this.props.description}>
				<div style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 10, paddingBottom: 10, display: 'flex', flexDirection: 'row' }}>
					<div className={"shop-button"} onClick={() => { this.onClick(price) }} style={{ cursor: 'pointer', flex: 1, height: 50, display: 'flex', flexDirection: 'row', borderStyle: 'solid', borderColor: '#6d6d6d', borderWidth: 1, justifyContent: 'space-between' }}>
						<div style={{ display: 'flex', flexDirection: 'row' }}>
							<div style={{ border: 0, borderRight: 1, borderColor: '#6d6d6d', borderStyle: 'solid', marginRight: 10 }}>
								{this.props.picture}
							</div>
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<div style={{ fontSize: 26, fontWeight: 600, lineHeight: 1 }}>{this.props.name}</div>
								{(price).toLocaleString('en-US', (price / 1000000000000000n > 0n) ? bigintFormatScientific : bigintFormatCompact )}
							</div>
						</div>
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 30, margin: 10 }}>
							{(this.props.count || 0).toString()}
						</div>
					</div>
				</div>
			</TooltipShop>
		)
	}
}